import React from 'react';
import CustomerInformationCard from './components/CustomerInformationCard';
import OrderPriceCard from './components/OrderPriceCard';
import AddressInformationCard from './components/AddressInformationCard/AddressInformationCard';
import { Grid } from '@mui/material';
import OrderInformationCard from './components/OrderInformationCard/OrderInformationCard';
import { UODC } from './userOrderDetails.classes';

function UserOrderDetailsCard({ datas, orderInformation, onRefreshOrderInformation }: any) {
    return (
        <Grid className={UODC.layout} container spacing={2}>
            <Grid
                className={UODC.sectionOrderInformation}
                size={{
                    xs: 12,
                    sm: 12,
                }}
            >
                <OrderInformationCard datas={datas} />
            </Grid>
            <Grid
                className={UODC.sectionCustomerInformation}
                size={{
                    xs: 12,
                    sm: 3,
                }}
            >
                <CustomerInformationCard customerId={datas.customerId} />
            </Grid>
            <Grid
                className={UODC.sectionOrderPrice}
                size={{
                    xs: 12,
                    sm: 3,
                }}
            >
                <OrderPriceCard datas={datas} />
            </Grid>
            <Grid
                className={UODC.sectionAddressInformation}
                size={{
                    xs: 12,
                    sm: 6,
                }}
            >
                <AddressInformationCard
                    orderId={datas}
                    orderInformation={orderInformation}
                    onRefreshOrderInformation={onRefreshOrderInformation}
                />
            </Grid>
        </Grid>
    );
}

export default UserOrderDetailsCard;
